$(document).ready(function() {
  $('.loaderSpinner').hide();
  $('.loading-first').show();
});

$(window).load(function(){
  $('.loading-first').hide();
  $('.filter-and-search').show();
  var $grid = $('.artists-isotope').isotope({
        itemSelector: '.artists-wrapper',
        percentPosition: true,
        masonry: {
          columnWidth: '.grid-sizer'
        },
        filter: function() {
          var $this = $(this);
          var searchResult = qsRegex ? $this.text().match( qsRegex ) : true;
          var buttonResult = buttonFilter ? $this.is( buttonFilter ) : true;
          return searchResult && buttonResult;
        }
      });

  // effect when show
  var $items = $grid.find('.artists-wrapper');
  // $items.addClass('is-showing-items');
  // $grid.isotope('revealItemElements', $items);
  
  // quick search regex
  var qsRegex;
  var buttonFilter;

  $('.filter-button-group').on('click', 'button', function() {
    if (!$(this).hasClass('active')) {
      $(this).addClass('active').siblings().removeClass('active');
      buttonFilter = $(this).attr('data-filter');
      $grid.isotope();
      loadMoreNoScroll();
    } 
  });


  // use value of search field to filter
  var $quicksearch = $('.quicksearch').keyup(debounce(function() {
    qsRegex = new RegExp( $quicksearch.val(), 'gi' );
    $grid.isotope();
    loadMoreNoScroll(); 
    $('#load-more').trigger('click');  
  }, 200));

  // debounce so filtering doesn't happen every millisecond
  function debounce( fn, threshold ) {
    var timeout;
    threshold = threshold || 100;
    return function debounced() {
      clearTimeout( timeout );
      var args = arguments;
      var _this = this;
      function delayed() {
        fn.apply( _this, args );
      }
      timeout = setTimeout( delayed, threshold );
    };
  }

  // Isotope Load more button
  var initShow = 16;
  var counter = initShow;
  var iso = $grid.data('isotope');

  loadMore(initShow);

  function loadMore(toShow) {
    // $grid.find('.is-showing-items').addClass('hidden').removeClass('is-showing-items is-showing');
    // $grid.find('.hidden').removeClass('hidden').addClass('is-showing-items is-showing');
    // var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
    //   return item.element;
    // });
    // $(hiddenElems).addClass('hidden').removeClass('is-showing-items is-showing');

    var showElems = iso.filteredItems.slice(0, toShow).map(function(item) {
      return item.element;
    });
    $(showElems).addClass('is-showing-items');
    $grid.isotope('layout');

    // setTimeout(function(){
    //   $('.is-showing').removeClass('is-showing');
    // }, 800);

    // when no more to load, hide show more button
    if (showElems.length >= iso.filteredItems.length) {
      jQuery('#load-more').addClass('hidden');
    } else {
      jQuery('#load-more').removeClass('hidden');
    };
  }

  // append load more button
  $grid.after('<div class="rbs_load_button"><button id="load-more">Loadmore</button></div>');

  // when load more button clicked
  $('#load-more').on('click', function() {
    if ($('#filters').data('clicked')) {
      //when filter button clicked, set initial value for counter
      counter = initShow;
      $('#filters').data('clicked', false);
    } else {
      counter = counter;
    };
    counter = counter + initShow;
    loadMore(counter);
  });

  // loadMoreNoScroll();
  // trigger click loading when scroll
  var windowH = $(window).height();
  $(window).scroll(function(){
    if (!$('#load-more').hasClass('hidden')) {
      var windowPos = $(this).scrollTop(),
        loadmorePos = $('#load-more').offset().top,
        pos = loadmorePos - windowH - 500;
      if(windowPos > pos) {
        $('#load-more').trigger('click'); 
      }
    }
  });
  
  $(window).resize(function(){
    $grid.isotope('layout');
  });
});

function loadMoreNoScroll() { 
  // trigger click loading when scroll
  var windowH = $(window).height();
  if (!$('#load-more').hasClass('hidden')) {
    var windowPos = $(this).scrollTop(),
      loadmorePos = $('#load-more').offset().top,
      pos = loadmorePos - windowH;
    if(windowPos > pos) {
      $('#load-more').trigger('click'); 
    }
  }
}